import { Flex, Space, Text, Title } from '@mantine/core';
import { useRouter } from '@tanstack/react-router';

import { translate } from '@/shared/i18n/translate';
import { LBButton } from '@/shared/ui-kit/components';
import { Logo } from '@/shared/ui-kit/icons/Logo';

export const NotFoundWorkItem = () => {
  const router = useRouter();
  return (
    <div
      style={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Space h={45} />
      <Flex align='center' justify='center'>
        <Logo
          style={{
            color: 'var(--mantine-primary-color)'
          }}
        />
      </Flex>
      <Space h={48} />
      <Flex
        align='center'
        bg='white'
        direction='column'
        justify='center'
        style={{
          padding: 20,
          paddingTop: 40,
          borderRadius: 16
        }}
      >
        <Space h={16} />
        <Title order={3} ta='center'>
          {translate('pages.notFoundWorkItem.title')}
        </Title>
        <Space h={8} />
        <Text fz={14} ta='center'>
          {translate('pages.notFoundWorkItem.description')}
        </Text>
        <Space h={32} />
        <LBButton
          fullWidth
          onClick={() => {
            router.history.back();
          }}
        >
          {translate('commons.back')}
        </LBButton>
      </Flex>
    </div>
  );
};
